import { Component, Vue, Mixins } from 'vue-property-decorator';
import { AllComponents } from '@/components/AllComponents';
import CommonView from '@/views/CommonView';
import { Breadcrumb } from '@/components/SBBreadcrumb';
import SBAPI from '@/util/SBAPI';
import { AxiosErrorHandler, isAxiosError } from '@/util/AxiosErrorHandler';

@Component({
    components: AllComponents(),
})
export default class NewsAbout extends Mixins(CommonView) {
    public breadcrumb: Breadcrumb[] = [
        {
            title: "NEWS"
            // ,to: "/news"
        },
        {
            title: ""
            // title: ncat.category
        },
    ];

    public date: string = "";
    public title: string = "";
    public message: string = "";
    public news: SBAPI.News = SBAPI.news();

    public async created() {
        let newsList = await SBAPI.NewsController.getNewsUsingGET(Number(this.$route.params.id), <any>this.$route.query.user).catch(AxiosErrorHandler);
        if (isAxiosError(newsList)) {
            return;
        }
        this.news = newsList.data;
        this.date = this.dateFormatSimple(this.news.openDate!)
        this.title = this.news.title;
        this.message = this.news.message;
    }

}
